import { css } from '@emotion/react';
import { SerializedStyles } from '@emotion/react/dist/emotion-react.cjs';
import globalStyle from '../../../../shared/global.style';

const headerContainer = css`
  position: relative;
  margin-bottom: 14px;
  ${globalStyle.stickyHeader(`var(--dcd-white-color)`)};
`;

const container = css`
  height: 100%;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

const tabsContainer = css`
  display: flex;
  justify-content: space-between;
  margin-top: 7px;
  margin-bottom: 7px;
`;

const selectedTab = css`
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
  background-color: var(--dcd-secondary-color-40);
`;

const tabButton = (selected: boolean): SerializedStyles => {
  return css`
    cursor: pointer;
    border-radius: 20px;
    padding: 5px 0;
    width: 50%;
    text-align: center;
    ${globalStyle.bodyNormal};
    ${selected ? selectedTab : ''};
  `;
};

export default {
  container,
  headerContainer,
  tabsContainer,
  tabButton,
};
